import { c as _c } from "react/compiler-runtime";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@repo/ui/components/ui/select";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import { useSetAtom } from "jotai";
import { useMemo } from "react";
import { mobileSheetOpenAtom } from "@/lib/atoms/nav.atoms";
import { trpc } from "@/router";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CategorySelect() {
  const $ = _c(24);
  const navigate = useNavigate();
  const routerState = useRouterState();
  const setIsOpen = useSetAtom(mobileSheetOpenAtom);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = trpc.experiences.categories.all.queryOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: t1
  } = useQuery(t0);
  let t2;
  if ($[1] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const categories = t2;
  let t3;
  if ($[3] !== routerState.matches) {
    t3 = routerState.matches.find(_temp);
    $[3] = routerState.matches;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const match = t3;
  const currentSlug = match?.params?.slug;
  let t4;
  bb0: {
    if (!currentSlug) {
      t4 = null;
      break bb0;
    }
    let t5;
    if ($[5] !== categories || $[6] !== currentSlug) {
      t5 = categories.find(cat => cat.slug === currentSlug) || null;
      $[5] = categories;
      $[6] = currentSlug;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t4 = t5;
  }
  const selectedCategory = t4;
  let t5;
  if ($[8] !== categories || $[9] !== navigate || $[10] !== setIsOpen) {
    t5 = value => {
      if (value === "all") {
        navigate({
          to: "/"
        });
      } else {
        const category = categories.find(cat_0 => String(cat_0.id) === value);
        if (category) {
          navigate({
            to: "/upplevelser/kategori/$slug",
            params: {
              slug: category.slug
            }
          });
        }
      }
      setIsOpen(false);
    };
    $[8] = categories;
    $[9] = navigate;
    $[10] = setIsOpen;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const onValueChange = t5;
  const currentValue = selectedCategory ? String(selectedCategory.id) : "all";
  const displayText = selectedCategory ? selectedCategory.name : "Alla kategorier";
  let t6;
  if ($[12] !== displayText) {
    t6 = /*#__PURE__*/_jsx(SelectTrigger, {
      className: "w-full bg-card md:w-[180px] h-9 dark:bg-card",
      children: /*#__PURE__*/_jsx(SelectValue, {
        children: displayText
      })
    });
    $[12] = displayText;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = /*#__PURE__*/_jsx(SelectItem, {
      value: "all",
      children: "Alla kategorier"
    });
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== categories) {
    t8 = categories.map(_temp2);
    $[15] = categories;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = /*#__PURE__*/_jsxs(SelectContent, {
      children: [t7, t8]
    });
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== currentValue || $[20] !== onValueChange || $[21] !== t6 || $[22] !== t9) {
    t10 = /*#__PURE__*/_jsxs(Select, {
      onValueChange: onValueChange,
      value: currentValue,
      children: [t6, t9]
    });
    $[19] = currentValue;
    $[20] = onValueChange;
    $[21] = t6;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
function _temp2(category_0) {
  return /*#__PURE__*/_jsx(SelectItem, {
    value: String(category_0.id),
    children: category_0.name
  }, category_0.id);
}
function _temp(m) {
  return m.routeId === "/_public/upplevelser/kategori/$slug";
}